import PropTypes from 'prop-types';

export default {
  id: PropTypes.number,
  color: PropTypes.string,
  uid: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  measurements: PropTypes.array,
  shock: PropTypes.array,
  events: PropTypes.array,
  locations: PropTypes.array
};
